import { render, staticRenderFns } from "./UserDocuments.vue?vue&type=template&id=21bf622c&"
import script from "./UserDocuments.vue?vue&type=script&lang=js&"
export * from "./UserDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports